// src/api/admin/recentActivities.js
import { api } from "../client";

/**
 * Get recent activities for the whole system (admin).
 * GET /api/method/dynesourcerapi.api.get_recent_activities?limit=50&for_admin=1
 * @param {Object} params
 * @param {number} [params.limit=50]
 * @param {number} [params.for_admin=1]
 * @returns {Promise<{ ok: boolean, items: Array }>}
 */
export async function getRecentActivities(params = {}) {
  const response = await api.get("/api/method/dynesourcerapi.api.get_recent_activities", {
    params: { limit: 50, for_admin: 1, ...params },
  });
  const data = response?.data;
  const message = data?.message;
  if (message && typeof message.ok !== "undefined") {
    return { ok: message.ok, items: Array.isArray(message.items) ? message.items : [] };
  }
  if (Array.isArray(data?.items)) {
    return { ok: true, items: data.items };
  }
  return { ok: false, items: [] };
}
